import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import Overlay from '../../legos/Overlay';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import DeviationDumbView from '../../../Dumbo';
import Timestamp from '../../../../Timestamp';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import s from './StatusThumb.scss';
const StatusThumb = ({ className, deviation, height, responsive, style, width, extraActions })=>{
    var _deviation_status;
    const { showOverlay, __forceHoveredForStories } = useOverlayContext(deviation);
    const canShowTimeStamp = width && width > 150 && height && height > 150;
    return /*#__PURE__*/ React.createElement(HoverableWrapper, {
        className: classnames(s['root'], className),
        style: _object_spread({
            width,
            height
        }, style),
        __forceHoveredForStories: __forceHoveredForStories
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "StatusThumb"
    }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
        deviation: deviation,
        width: width,
        height: height,
        responsive: responsive
    }), canShowTimeStamp && /*#__PURE__*/ React.createElement(HoverOnly, {
        reverseHidden: true,
        className: s['status-date']
    }, /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: deviation.publishedTime || ((_deviation_status = deviation.status) === null || _deviation_status === void 0 ? void 0 : _deviation_status.ts)
    })), /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation,
        className: s['link-overlay'],
        title: deviation.title
    }, /*#__PURE__*/ React.createElement("span", null)), showOverlay && /*#__PURE__*/ React.createElement(Overlay, {
        deviation: deviation,
        width: width,
        height: height,
        className: s['overlay'],
        extraActions: extraActions
    })));
};
StatusThumb.displayName = 'StatusThumb';
export default StatusThumb;
